import ListItemReceives from "../../../../components/@documents/item_receives/ListItemReceives";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemReceivesPage() {

    return (
        <ListItemReceives 
            routeType={routeTypes.admin}
        />
    )
}